import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.background,
    },
    containerHistory: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerInput: {
        flex: 1,
        paddingHorizontal: 10,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginVertical: 10,
    },
    input: {
        flex: 1,
        color: theme.colors.textPrimary,
    },
    icon: {
        position: 'absolute',
        right: 10,
        backgroundColor: 'white',
    },
    textSection: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'left',
        marginHorizontal: 12,
    },
    textSectionDescription: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'left',
        marginHorizontal: 12,
    },
    image: {
        width: 200,
        height: 200,
        aspectRatio: 1,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        paddingHorizontal: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    description: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        paddingHorizontal: 25,
        textAlign: 'center',
        lineHeight: 20,
    },
    buttonContainer: {
        flexDirection: 'column',
        paddingHorizontal: 12,
        width: '100%',
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    floatingButton: {
        marginVertical: 12,
        padding: 10,
    },
    floatingButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    vouchersModule: {
        padding: 0,
        flexDirection: 'row',
        marginHorizontal: 12,
        marginVertical: 12,
        borderRadius: 10,
    },
    voucherImage: {
        flex: 1.6,
        aspectRatio: 1,
        borderRadius: 10,
    },
    voucherDate: {
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        marginLeft: 12,
    },
    voucherTitle: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        lineHeight: 18,
        marginLeft: 12,
        marginTop: 4,
    },
    voucherDescription: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        lineHeight: 18,
        marginLeft: 12,
        marginTop: 4,
    },
    viewMore: {
        fontSize: 13,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        marginHorizontal: 12,
        marginTop: 5,
    },
    divider: {
        height: 1,
        width: Dimensions.get('window').width - 24,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 12,
    },
    separator: {
        height: 4,
    },
    spacer: {
        height: 6,
    },
    spacer1: {
        height: 12,
    },
})

export default styles
